import { calculateDeliveryTimeForProduct } from '@/helper/functions';
import ShopItem from '@/model/ShopItem';

export const level1Store = {
  state: {
    level1Preview: null,
    listItemsLevel1: [],
    extraLevel1: [],
    level1Filter: {
      categories: [],
      tags: [],
      sort: { name: '' },
      b2b: { qty: 0, time: -1 },
      priceMin: 0,
      priceMax: 999999,
      useB2cPrices: false
    },
    dontSwitchView: false
  },
  getters: {
    getExtraLevel1: state => {
      return state.extraLevel1;
    },
    getListItemsLevel1Unfiltered: state => {
      return state.listItemsLevel1;
    },
    getLevel1Preview: state => {
      return state.level1Preview;
    },
    getListItemsLevel1Filtered: (state, getters, rootState) => {
      const today = new Date();
      return getters.getListItemsLevel1.filter(function(box) {
        var valid = true;
        if (state.level1Filter.b2b.qty > 0 && valid) {
          box.products.forEach(function(product) {
            if (product.replaced) {
              product = product.replaceData;
            }

            if (
              !(
                product.custom_delivery_qty.allow_backorders === 'ja' ||
                (product.stock_status === 'instock' &&
                  product.stock_quantity >= state.level1Filter.b2b.qty) ||
                new Date(product.release_date) > today
              ) || !product.type === 'box'
            ) {
              valid = false;
            }
            if (
              (state.level1Filter.b2b.qty < 20 &&
              product.stock_quantity < state.level1Filter.b2b.qty &&
              new Date(product.release_date) < today) && product.type !== 'box'
            ) {
              valid = false;
            }
          });
        }

        var countNot = 0;
        box.products.forEach(function(product) {
          if (product.replaced) {
            product = product.replaceData;
          }
          if (
            valid &&
            state.level1Filter.categories.length > 0 &&
            !state.level1Filter.categories.some(r => product.category.includes(r))
          ) {
            ++countNot;
          }
        });

        if (valid && state.level1Filter.tags.length > 0) {
          var allTagsIncluded = true;
          state.level1Filter.tags.forEach(element => {
            var thisIncluded = false;
            box.level1_tags.forEach(item => {
              if (item.level1_feature_title === element) {
                thisIncluded = true;
              }
            });
            if (!thisIncluded) {
              allTagsIncluded = false;
            }
          });
          if (!allTagsIncluded) {
            valid = false;
          }
        }

        if (valid) {
          valid = !(countNot === box.products.length);
        }

        if (state.level1Filter.b2b.time === 0 && valid) {
          box.products.forEach(function(product) {
            if (product.replaced) {
              product = product.replaceData;
            }
            if (product.stock_quantity < state.level1Filter.b2b.qty) {
              valid = false;
            }
          });
        }

        if (state.level1Filter.b2b.time > 0 && valid) {
          box.products.forEach(function(product) {
            if (product.replaced) {
              product = product.replaceData;
            }
            if (
              state.level1Filter.b2b.time <
              calculateDeliveryTimeForProduct(
                product,
                state.level1Filter.b2b.qty,
                getters.getDelTimeSettings
              )
            ) {
              valid = false;
            }
          });
        }

        return valid;
      }).sort((a, b) => {
        if (state.level1Filter.categories.length > 0) {
          let bIndex = -1;
          let aIndex = -1;
          b.products.forEach(function(product) {
            const i = state.level1Filter.categories.indexOf(product.category[0]);
            if (i > bIndex) {
              bIndex = i;
            }
          });
          a.products.forEach(function(product) {
            const i = state.level1Filter.categories.indexOf(product.category[0]);
            if (i > bIndex) {
              aIndex = i;
            }
          });

          return bIndex - aIndex;
        }

        return 0;
      });
    },
    getListItemsLevel1FilterWithoutQty: (state, getters, rootState) => {
      return state.listItemsLevel1.filter(function(box) {
        var valid = true;

        var countNot = 0;
        box.products.forEach(function(product) {
          if (
            valid &&
            state.level1Filter.categories.length > 0 &&
            !state.level1Filter.categories.some(r => product.category.includes(r))
          ) {
            ++countNot;
          }
        });

        if (valid) {
          valid = !(countNot === box.products.length);
        }

        if (state.level1Filter.b2b.time === 0 && valid) {
          box.products.forEach(function(product) {
            if (product.stock_quantity < state.level1Filter.b2b.qty) {
              valid = false;
            }
          });
        }

        if (state.level1Filter.b2b.time > 0 && valid) {
          box.products.forEach(function(product) {
            if (
              state.level1Filter.b2b.time <
              calculateDeliveryTimeForProduct(
                product,
                state.level1Filter.b2b.qty,
                getters.getSettings
              )
            ) {
              valid = false;
            }
          });
        }

        return valid;
      }).sort((a, b) => {
        if (state.level1Filter.categories.length > 0) {
          let bIndex = -1;
          let aIndex = -1;
          b.products.forEach(function(product) {
            const i = state.level1Filter.categories.indexOf(product.category[0]);
            if (i > bIndex) {
              bIndex = i;
            }
          });
          a.products.forEach(function(product) {
            const i = state.level1Filter.categories.indexOf(product.category[0]);
            if (i > bIndex) {
              aIndex = i;
            }
          });

          return bIndex - aIndex;
        }

        return 0;
      });
    },
    getListItemsLevel1: (state, getters, rootState) => {
      var itemsToRet = [];
      const today = new Date();
      if (state.level1Filter.sort.name === '__begin') {
        const ret = [];
        state.listItemsLevel1.forEach(function(item) {
          if (item.id === state.level1Filter.sort.value) {
            ret.unshift(item);
          } else {
            ret.push(item);
          }
        });

        itemsToRet = ret;
      } else if (state.level1Filter.sort.name === '__hasProduct') {
        const ret = [];
        const ret2 = [];
        state.listItemsLevel1.forEach(function(item) {
          var addItem = 0;
          item.products.forEach(function(product) {
            if (product.product === state.level1Filter.sort.id) {
              addItem = 1;
            } else if (
              product.manufacturer === state.level1Filter.sort.manufacturer
            ) {
              if (addItem === 0) {
                addItem = 2;
              }
            }
          });

          if (addItem === 1) {
            ret.unshift(item);
          } else if (addItem === 2) {
            ret.push(item);
          } else {
            ret2.push(item);
          }
        });

        itemsToRet = ret.concat(ret2);
      } else if (state.level1Filter.sort.name === '__event') {
        if (
          !state.level1Filter.sort.onlyB2b ||
          (state.level1Filter.sort.onlyB2b && state.level1Filter.sort.isB2b)
        ) {
          const tags = state.level1Filter.sort.value.split(',');
          const ret = [];
          const ret2 = [];
          var i = 0;

          for (i = 0; i < tags.length; ++i) {
            ret.push([]);
          }
          state.listItemsLevel1.forEach(function(item) {
            var added = false;
            item.products.forEach(function(product) {
              for (i = 0; i < tags.length; ++i) {
                if (product.event.includes(tags[i]) && !added) {
                  ret[i].push(item);
                  added = true;
                }
              }
            });
            if (!added) {
              ret2.push(item);
            }
          });

          var final = [];
          for (i = 0; i < tags.length; ++i) {
            final = final.concat(ret[i]);
          }

          itemsToRet = final.concat(ret2);
        } else {
          itemsToRet = state.listItemsLevel1;
        }
      } else {
        itemsToRet = state.listItemsLevel1;
      }
      return itemsToRet.filter(function(box) {
        var ret = true;
        box.products.forEach(product => {
          if (product.replaced) {
            product = product.replaceData;
          }
          if (
            (((product.stock_status !== 'instock' &&
              getters.getSelectedQty < 20) ||
              (product.stock_quantity < getters.getSelectedQty &&
                (getters.getSelectedQty < 20 ||
                  product.custom_delivery_qty.allow_backorders !== 'ja'))) &&
            new Date(product.release_date) < today) && product.type !== 'box'
          ) {
            ret = false;
          }
        });
        return ret;
      });
    },
    getLevel1Filter: state => {
      return state.level1Filter;
    },
    getDontSwitchView: state => {
      return state.dontSwitchView;
    }
  },
  mutations: {
    setExtraLevel1(state, extraItems) {
      state.extraLevel1 = extraItems;
    },
    setLevel1Preview(state, previewItem) {
      if (previewItem === null) {
        state.level1Preview = null;
      } else {
        var item = new ShopItem();
        item.data = previewItem;
        state.level1Preview = item;
      }
    },
    setListItemsLevel1(state, items) {
      state.listItemsLevel1 = items;
    },
    setLevel1FilterSort(state, sort) {
      state.level1Filter.sort = sort;
    },
    setLevel1FilterB2bQty(state, qty) {
      state.level1Filter.b2b.qty = qty;
    },
    setLevel1FilterB2bTime(state, time) {
      state.level1Filter.b2b.time = time;
    },
    clearLevel1FilterB2b(state) {
      state.level1Filter.b2b = { qty: 0, time: -1 };
    },
    setLevel1FilterMinPrice(state, price) {
      state.level1Filter.priceMin = price;
    },
    setLevel1FilterMaxPrice(state, price) {
      state.level1Filter.priceMax = price;
    },
    setLevel1FilterUseB2cPrices(state, value) {
      state.level1Filter.useB2cPrices = value;
    },
    addLevel1FilterCategory(state, category) {
      state.level1Filter.categories.push(category);
    },
    addLevel1FilterTag(state, tag) {
      state.level1Filter.tags.push(tag);
    },
    removeLevel1FilterCategory(state, category) {
      const newCategories = [];
      state.level1Filter.categories.forEach(c => {
        if (c !== category) {
          newCategories.push(c);
        }
      });
      state.level1Filter.categories = newCategories;
    },
    removeLevel1FilterTag(state, tag) {
      const newTags = [];
      state.level1Filter.tags.forEach(c => {
        if (c !== tag) {
          newTags.push(c);
        }
      });
      state.level1Filter.tags = newTags;
    },
    clearLevel1FilterCategory(state) {
      state.level1Filter.categories = [];
    },
    clearLevel1FilterTag(state) {
      state.level1Filter.tags = [];
    },
    setDontSwitchView(state, value) {
      state.dontSwitchView = value;
    }
  }
};
